import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from "@mui/material";

const DialogSuppressionGroupe = ({ open, onClose, onConfirm, t }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t("ConfirmDeleteGroupTitle")}</DialogTitle>
      
      <DialogContent>
        {t("ConfirmDeleteGroup")}
      </DialogContent>
      
      <DialogActions>
        <Button
          size="small"
          onClick={onClose}
          sx={{ paddingX: 1.5, paddingY: 0.5, fontSize: "0.8rem" }}
        >
          {t("Cancel")}
        </Button>
        <Button
          size="small"
          color="error"
          variant="contained"
          onClick={onConfirm}
        >
          {t("Delete") || "Supprimer"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogSuppressionGroupe;
